// extracted by mini-css-extract-plugin
export var cardContainer = "header_cardContainer__21Yu1";
export var container = "header_container__r6Qye";
export var feature = "header_feature__wX7dD";
export var fffCard = "header_fffCard__baeZU";
export var promoFeatures = "header_promoFeatures__6XOWb";
export var row = "header_row__ymcwm";
export var sendGiftLink = "header_sendGiftLink__M5tSd";
export var subtitle = "header_subtitle__HPs9R";
export var title = "header_title__KHTrN";